exports.components = {
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-about-me-jsx": () => import("./../../../src/pages/about-me.jsx" /* webpackChunkName: "component---src-pages-about-me-jsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-pages-photos-jsx": () => import("./../../../src/pages/photos.jsx" /* webpackChunkName: "component---src-pages-photos-jsx" */),
  "component---src-pages-video-jsx": () => import("./../../../src/pages/video.jsx" /* webpackChunkName: "component---src-pages-video-jsx" */)
}

